
// import React, { useEffect } from "react";
// import AOS from "aos";
// import "aos/dist/aos.css";
// import { Element } from "react-scroll";

// // import Navbar from "./pages/Navbar";
// import Hero from "./pages/Hero";
// import Testimonials from "./components/TestimonialCard";
// import About from "./pages/About";
// import Services from "./pages/Services";
// import Gallery from "./pages/Gallery";
// import Contact from "./pages/Contact";
// // import MiniTestimonials from "./pages/minitestimonials";
// import OurTeam from "./pages/ourteam";

// function Home() {
//   useEffect(() => {
//     AOS.init({ duration: 1000 });
//   }, []);

//   return (
//     <>
//       {/* <Navbar /> */}
//       <Element name=""><Hero /></Element>
//       <Element name="about"><About /></Element>
//       <Element name="services"><Services /></Element>
//       <Element name="gallery"><Gallery /></Element>
//       <Element name="our-team"><OurTeam/></Element>
//       <Element name="testimonials"><Testimonials/></Element>
//       <Element name="contact"><Contact /></Element>
//     </>
//   );
// }

// export default Home;
  
// import React, { useEffect } from "react";
// import AOS from "aos";
// import "aos/dist/aos.css";
// import { Element } from "react-scroll";
// import { Link } from "react-router-dom";

// import Hero from "./pages/Hero";
// import Testimonials from "./components/TestimonialCard";
// import About from "./pages/About";
// import Services from "./pages/Services";
// import OurTeam from "./pages/ourteam";
// import Contact from "./pages/Contact";
// import GalleryImage from "./components/galleryimages";

// function Home() {
//   useEffect(() => {
//     AOS.init({ duration: 1000, once: true, offset: 100 });
//   }, []);

//   // Home page preview images
//   const previewImages = [
//     { src: "/Project pics/Work8 (3).jpg", caption: "Building Exterior" },
//     { src: "/Project pics/Work8 (6).jpg", caption: "Tennis Court Project" },
//     { src: "/Project pics/Work8 (1).jpg", caption: "Factory Painting" },
//     { src: "/Project pics/Work8 (2).jpg", caption: "Factory Painting" },
//     { src: "/Project pics/Work1.JPG", caption: "Factory Painting" },
//     { src: "/Project pics/Work2.JPG", caption: "Factory Painting" },
//   ];

//   return (
//     <>
//       {/* Hero Section */}
//       <Element name="">
//         <div data-aos="fade-up">
//           <Hero />
//         </div>
//       </Element>

//       {/* About Section */}
//       <Element name="about">
//         <div data-aos="fade-right">
//           <About />
//         </div>
//       </Element>

//       {/* Services Section */}
//       <Element name="services">
//         <div data-aos="fade-left">
//           <Services />
//         </div>
//       </Element>

//       {/* Gallery Preview Section */}
//       <Element name="gallery">
//         <section style={{ padding: "80px 0" }} data-aos="zoom-in">
//           <h2 style={{ textAlign: "center", marginBottom: "30px", color: "#008080" }}>
//             Project Gallery (Preview)
//           </h2>
//           <GalleryImage images={previewImages} />

//           {/* View All Button */}
//           <div style={{ textAlign: "center", marginTop: "25px" }}>
//             <Link
//               to="/gallery"
//               style={{
//                 display: "inline-block",
//                 backgroundColor: "#008080",
//                 color: "#fff",
//                 padding: "10px 20px",
//                 borderRadius: "6px",
//                 textDecoration: "none",
//                 fontWeight: "500",
//                 transition: "all 0.3s ease",
//               }}
//               onMouseOver={(e) => (e.target.style.backgroundColor = "#006666")}
//               onMouseOut={(e) => (e.target.style.backgroundColor = "#008080")}
//             >
//               View All →
//             </Link>
//           </div>
//         </section>
//       </Element>

//       {/* Our Team */}
//       <Element name="our-team">
//         <div data-aos="fade-up">
//           <OurTeam />
//         </div>
//       </Element>

//       {/* Testimonials */}
//       <Element name="testimonials">
//         <div data-aos="flip-up">
//           <Testimonials />
//         </div>
//       </Element>

//       {/* Contact */}
//       <Element name="contact">
//         <div data-aos="fade-up">
//           <Contact />
//         </div>
//       </Element>
//     </>
//   );
// }

// export default Home;



import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Element } from "react-scroll";
import { Link } from "react-router-dom";

import Hero from "./pages/Hero";
// import WhatsAppWidget from './components/WhatsappWidget';

import Testimonials from "./components/TestimonialCard";
import About from "./pages/About";
import Services from "./pages/Services";
// import OurTeam from "./pages/ourteam";
import Contact from "./pages/Contact";
import GalleryImage from "./components/galleryimages";

function Home() {
 useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  // Home page preview images (first 6 only)
  const previewImages = [
    { src: "/Project pics/Tennis1.JPG", caption: "Tennis Court" },
    { src: "/Project pics/marquee2.jpg", caption: "Marquee Project" },
    { src: "/Project pics/Work8 (1).jpg", caption: "Factory Painting" },
    { src: "/Project pics/marquee1.jpg", caption: "Marquee Painting" },
    { src: "/Project pics/Work1.JPG", caption: "Factory Painting" },
    { src: "/Project pics/Work7.JPG", caption: "Marquee Painting" },
    { src: "/Project pics/Velvet Touch Wall.jpg", caption: "Wall Painting" },
    { src: "/Project pics/Khyaban.JPG", caption: "Exterior Painting" },

  ];

  return (
    <>
      {/* Hero Section */}
      <Element name="">
        <section data-aos="fade-up">
          <Hero />
        </section>
      </Element>

      {/* About Section */}
      <Element name="about">
        <section>
       
          <div data-aos="fade-right">
            <About />
            
          </div>
        </section>
      </Element>

      {/* Services Section */}
      <Element name="services">
        <section style={{ padding: "-140px 0" }}>
          
          <div data-aos="fade-up">
            <Services />
          </div>
        </section>
      </Element>

      {/* Gallery Preview Section */}
      <Element name="gallery">
        <section style={{ padding: "80px 0" }}>
          <h2
            style={{ textAlign: "center", marginBottom: "30px", color: "#008080" }}
            data-aos="zoom-in"
          >
            Project Gallery (Preview)
          </h2>

          <div data-aos="fade-up">
            <GalleryImage images={previewImages} />
          </div>

          {/* View All Button */}
          <div style={{ textAlign: "center", marginTop: "25px" }} data-aos="fade-up">
            <Link
              to="/gallery"
              className="view-all-btn"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                backgroundColor: "#008080",
                color: "#fff",
                padding: "10px 20px",
                borderRadius: "6px",
                textDecoration: "none",
                fontWeight: "500",
                transition: "all 0.3s ease",
              }}
            >
              View All <span className="arrow">→</span>
            </Link>
          </div>
        </section>
      </Element>

      {/* Our Team */}
     

      {/* Testimonials */}
      <Element name="testimonials">
        <section style={{ padding: "80px 0" }}>
          
          <div data-aos="flip-up">
            <Testimonials />
          </div>
        </section>
      </Element>

      {/* Contact */}
      <Element name="contact">
        <section style={{ padding: "80px 0" }}>
          
          <div data-aos="fade-up">
            <Contact />
          </div>
        </section>
      </Element>
    </>
  );
}

export default Home;
